export default "__VITE_ASSET__vB_FVVx9__"